var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12025_27789",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12025_27789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49828 19.5003V7.6003L2.64453 3.54255L4.00203 2.9043L6.14053 7.5503H17.856L19.9945 2.9043L21.352 3.54255L19.4983 7.6003V19.5003H4.49828ZM9.99828 12.7503H13.9983C14.2108 12.7503 14.3889 12.6784 14.5325 12.5345C14.6764 12.3907 14.7483 12.2125 14.7483 12C14.7483 11.7874 14.6764 11.6093 14.5325 11.4658C14.3889 11.3221 14.2108 11.2503 13.9983 11.2503H9.99828C9.78578 11.2503 9.6077 11.3222 9.46403 11.466C9.3202 11.6099 9.24828 11.788 9.24828 12.0005C9.24828 12.2132 9.3202 12.3913 9.46403 12.5348C9.6077 12.6785 9.78578 12.7503 9.99828 12.7503Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.08f01ce99575467debfa3263fa1802b1.svg";
export { ForwardRef as ReactComponent };